import { appEnv } from '@/app/config/env';
import { AxiosAdapter } from '@/infra/adapters/http/axios-adapter';
import { IHttpClient } from '@/infra/interfaces/http/http-client';

function makeHttpClient(): IHttpClient {
  return new AxiosAdapter(appEnv.apiUrl, appEnv.apiKey);
}

export const httpClient = makeHttpClient();
